import gql from "graphql-tag";

export default gql`
	mutation updateBackOfficeUser($attributes: BackOfficeUserInput!, $role_id: ID!, $user_id: ID!) {
		updateBackOfficeUser(attributes: $attributes, roleId: $role_id, userId: $user_id) {
			id
		}
	}
`;
